export function alert(msg, opts) {
  opts = opts || {}
  if (!opts.disable_swal && typeof window.Swal !== 'undefined') {
    opts.title = msg
    window.Swal.fire(opts)
  } else {
    alert(msg)
  }
}
